import type { HelpFile } from '../../types/help'
import { EmptyStateTestIds } from '../../../testids/EmptyStateTestIds'

export const emptyStateHelp: HelpFile = {
  docPage: '/docs/help-system/components',
  texts: {
    [EmptyStateTestIds.emptyState]: null,
    [EmptyStateTestIds.emptyStateAction]: null,
    [EmptyStateTestIds.emptyStateDescription]: null,
    [EmptyStateTestIds.emptyStateIcon]: null,
    [EmptyStateTestIds.emptyStateTitle]: null,
  },
}
